export const CONTENT_PAGE_ARTICLE_IDS = [
  'contact',
  'commercial-contact',
  'articles-hub',
  'products-hub',
]

export const itemWithId = (array, id) => {
  if(!array) return null
  return array.find(i => i.id === id)
}

export const EXPORT_DATE_FORMAT = 'YYYY-MM-DD HH:mm'
export const EXPORT_DATE_FORMAT_SHORT = 'YYYY-MM-DD'

export const localizedProperty = (obj, property, locale = 'fr') => {
  if(!obj || !property) return ""
  if(!obj[property]) {
    return `Missing ${property}`
  }
  if(!obj[property][locale] && !obj[property].en) {
    return `Missing ${locale} ${property}`
  }
  if(obj[property][locale]) return obj[property][locale]
  if(obj[property].en) return obj[property].en
  return ""
}

export const eurAmountFormatter = (value) => {
  return parseFloat(value ?? 0).toFixed(2).replace('.', ',')
}
